type CellValue = {
  data: { value: boolean | number | string | object }
  value: boolean | number | string | object
}

export const BasicCellRenderer = (params: CellValue) => {
  return params.value
}

export const CompoundValueCellRenderer = (params: CellValue) => {
  if (params.value) {
    return (params.value as string).split(';')[1]
  } else if (params.data.value !== '') {
    return params.data.value
  }
}
